'use client'

import { useEffect } from 'react'

import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import _trim from 'lodash/trim'

import useStorage from '@/hooks/use-storage'
import { USER_AUTH_STORAGE_KEY } from '@/hooks/use-storage/use-storage.constants'
import { sentryConfig } from '@/lib/error/sentry'
import { isUserSessionValid } from '@/lib/user/auth'

export default function SentryUserSync() {
  const { value: userAuth, storageLoaded } = useStorage<UserAuth>(USER_AUTH_STORAGE_KEY)

  useEffect(() => {
    if (!storageLoaded) {
      return
    }

    if (_isEmpty(userAuth) || !isUserSessionValid(userAuth)) {
      sentryConfig.clearUser()
      return
    }

    const user = _get(userAuth, 'user')
    const email = _get(user, 'email')

    if (!email) {
      sentryConfig.clearUser()
      return
    }

    const userId = _get(user, 'id')
    const firstName = _get(user, 'firstName', '')
    const lastName = _get(user, 'lastName', '')
    const username = _trim(`${firstName} ${lastName}`) || undefined

    sentryConfig.setUser({
      email,
      ...(userId != null ? { id: String(userId) } : {}),
      ...(username ? { username } : {}),
    })
  }, [userAuth, storageLoaded])

  return null
}
